import { EMPTY_STRING, EMPTY_TASKS_JSON } from 'constants/general';
import { ToDoPlayerTask } from 'interfaces';
import { captureException } from 'services/posthog.service';
import { filterValidPlayerTasks } from 'utils/todo-player.util';

export type IncomingTasksPayload = {
  tasks?: unknown;
};

const parseTasksJsonString = (raw: string): ToDoPlayerTask[] => {
  const trimmed = raw.trim();
  if (trimmed === EMPTY_STRING || trimmed === EMPTY_TASKS_JSON) {
    return [];
  }
  try {
    const parsed: unknown = JSON.parse(trimmed);
    return Array.isArray(parsed)
      ? filterValidPlayerTasks(parsed as ToDoPlayerTask[])
      : [];
  } catch (err) {
    captureException(err);
    return [];
  }
};

/** Normalizes desktop metadata tasks (array, JSON string, "", or null). */
export const parseIncomingTasks = (
  data: IncomingTasksPayload
): ToDoPlayerTask[] => {
  const raw: unknown = data?.tasks;
  if (Array.isArray(raw)) {
    return filterValidPlayerTasks(raw as ToDoPlayerTask[]);
  }
  if (raw == null || raw === '') {
    return [];
  }
  if (typeof raw !== 'string') {
    return [];
  }
  return parseTasksJsonString(raw);
};
